import { SAMPLE_QUOTE } from './sampleQuote';

export const FLIGHT_TRACKING_SAMPLE = {
  quote: SAMPLE_QUOTE,
  trackingUrl: { url: 'https://gotrustjet.com/track/sample?token=abc' },
  flights: [
    { departure_airport: 'TEB', arrival_airport: 'MIA', departure_date: '2025-10-24T10:00:00Z' },
    { departure_airport: 'MIA', arrival_airport: 'TEB', departure_date: '2025-10-28T14:00:00Z' },
  ],
};
